import { Component, OnInit } from '@angular/core';
import { BaseControlComponent } from '../../../../../../form-controls/components/base-control/base-control.component';
import { ContextInteractionService } from '../../../../../../form-controls/services/context-interaction.service';

@Component({
    selector: 'app-empty-data-config',
    templateUrl: './empty-data-config.component.html',
    standalone: false
})
export class EmptyDataConfigComponent extends BaseControlComponent {
    static componentName = 'EmptyDataConfigComponent';

    constructor(public readonly contextService: ContextInteractionService) {
        super(contextService);
    }
}
